import { useEffect, useState } from "react";
import { api } from "./api";

let cache = null;

export const useBlipColors = () => {
  const [colors, setColors] = useState(cache || []);
  useEffect(() => {
    if (cache) return;
    api.get("/blip-colors").then(({ data }) => {
      cache = data;
      setColors(data);
    }).catch(() => {});
  }, []);
  return colors;
};

const rgb = (hex) => {
  const m = /^#?([0-9a-f]{6})$/i.exec(hex || "");
  if (!m) return null;
  const n = parseInt(m[1], 16);
  return [n >> 16, (n >> 8) & 255, n & 255];
};

// mesma regra do recurso FiveM (client/main.lua): distância RGB mínima, ignora auto=false, empate = id mais baixo
export const nearestBlip = (hex, colors) => {
  const t = rgb(hex);
  if (!t) return null;
  let best = null;
  let bestD = Infinity;
  colors.forEach((c) => {
    if (!c.auto) return;
    const p = rgb(c.hex);
    const d = (p[0] - t[0]) ** 2 + (p[1] - t[1]) ** 2 + (p[2] - t[2]) ** 2;
    if (d < bestD) {
      bestD = d;
      best = c;
    }
  });
  return best;
};

export const resolveBlip = (blipColor, hex, colors) => {
  const s = String(blipColor ?? "").trim();
  if (s === "") return { color: nearestBlip(hex, colors), auto: true };
  return { color: /^\d+$/.test(s) ? colors.find((c) => c.id === Number(s)) || null : null, auto: false };
};
